import template from './createNewInsuranceFileModal.html';
import controller from './createNewInsuranceFileModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    familyId: '<',
    file: '<',
    files: '<',
    statuses: '<',
  },
};
